import { cva } from '@/styled-system/css';

export const progressBarRecipe = cva({
  base: { position: 'relative' },
  variants: {
    size: {
      sm: { height: 'ProgressIndicator.bar.sm.height' },
      md: { height: 'ProgressIndicator.bar.md.height' },
    },
  },
});
